import React from 'react';
import { connect } from 'dva';
import PropTypes from 'prop-types';
import styles from './FeatureDetailPhotos.module.scss';
import PhotosPanel from '../../Panel/Photos';

const FeatureDetailPhotos = (props) => {
  return (
    <div className={styles.photosContainer}>
      <PhotosPanel />
    </div>
  );
};

FeatureDetailPhotos.propTypes = {
};

export default connect((model) => ({
}))(FeatureDetailPhotos);